import s from './PrintPage.scss'
import cn from 'classnames'
import { FaMinusCircle, FaCopy, FaArrowAltCircleUp, FaArrowAltCircleDown } from 'react-icons/fa'

const PrintPage = ({
  type,
  children,
  removePage,
  duplicatePage,
  isFirstPage,
  isLastPage,
  reorderPage
}) => {
  return (
    <div
      className={cn(s.page, {
        [s.a4]: type === 'a4',
        [s.letter]: type === 'letter'
      })}
    >
      {children}
      {removePage && (
        <FaMinusCircle className={cn('remove-for-pdf-js', s.remove)} onClick={removePage} />
      )}
      {duplicatePage && (
        <FaCopy className={cn('remove-for-pdf-js', s.copy)} onClick={duplicatePage} />
      )}
      {reorderPage && (
        <div className={s.reorder}>
          <FaArrowAltCircleUp
            className={cn('remove-for-pdf-js', { [s.disabled]: isFirstPage })}
            onClick={() => {
              if (isFirstPage) return
              reorderPage(-1)
            }}
          />
          <FaArrowAltCircleDown
            className={cn('remove-for-pdf-js', { [s.disabled]: isLastPage })}
            onClick={() => {
              if (isLastPage) return
              reorderPage(1)
            }}
          />
        </div>
      )}
    </div>
  )
}

export default PrintPage
